(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-announcement-bar"] && !Shopify.designMode) return;
  try {
    class StickyAnnouncement extends HTMLElement {
    static get observedAttributes() {
      return ['auto-rotate', 'auto-rotate-interval'];
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.sticky-announcement__slide'));
      this.activeIndex = this.slides.findIndex((slide) => slide.hasAttribute('data-active'));

      if (this.activeIndex === -1 && this.slides.length) {
        this.activeIndex = 0;
        this.slides[0].setAttribute('data-active', '');
      }

      this.#setupAutoRotate();
    }

    attributeChangedCallback() {
      this.#setupAutoRotate();
    }

    disconnectedCallback() {
      this.#clearTimer();
    }

    #setupAutoRotate() {
      this.#clearTimer();

      if (!this.hasAttribute('auto-rotate') || this.slides.length <= 1) return;

      const interval = Number(this.getAttribute('auto-rotate-interval')) || 5;
      this.timer = setInterval(() => {
        this.#advanceSlide();
      }, interval * 1000);
    }

    #advanceSlide() {
      if (this.slides.length <= 1) return;

      this.slides[this.activeIndex].removeAttribute('data-active');
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      this.slides[this.activeIndex].setAttribute('data-active', '');
    }

    #clearTimer() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('sticky-announcement')) {
    customElements.define('sticky-announcement', StickyAnnouncement);
  }
  } catch(e) { console.error(e); }
})();

})();
